import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useAppSelector } from 'src/Hooks/redux'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { getAllCampaignsCount, useMetadataQuery } from 'src/Redux/metadataApi'
import { getUserCreatedAt } from 'src/Redux/auth-process/userSlice/selectors'

import { CreateNewCampaignHelmet } from '../../Components/CreateNewCampaignHelmet'
import { CreateCampaignBreadcrumbsAuth } from '../../Components/CreateCampaignBreadcrumbsAuth'
import { ReleaseTypeItem } from '../../Components/ReleaseTypeItem'

import { shouldShowNewLabel } from './helpers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  max-width: 960px;
`

const ReleaseTypesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const ChooseReleaseTypeAuthPage: FC = () => {
  const navigate = useNavigate()
  const { data: campaigns } = useMetadataQuery(null)
  const userCreatedAt = useAppSelector(getUserCreatedAt)
  const showNewLabel = shouldShowNewLabel({
    campaignsCount: getAllCampaignsCount(campaigns),
    userCreatedAt,
  })

  const onReleasedClick = (): void => {
    navigate(ArtistRoutesEnum.ChooseCreateCampaignPlatformSpotify)
  }

  const onNotReleasedClick = (): void => {
    navigate(ArtistRoutesEnum.CreatePreReleaseTrackDetails)
  }

  return (
    <>
      <CreateNewCampaignHelmet />
      <Container>
        <CreateCampaignBreadcrumbsAuth />
        <ReleaseTypesContainer>
          <ReleaseTypeItem
            title='My track is already released'
            description='Pitch your released track to playlist curators. Get feedback and secure playlist placements.'
            onClick={onReleasedClick}
          />
          <ReleaseTypeItem
            {...(showNewLabel && { labelText: 'New' })}
            title='My track is NOT released yet'
            description='Pitch your upcoming release to playlist curators in advance. Get early feedback and secure placements for release day.'
            onClick={onNotReleasedClick}
          />
        </ReleaseTypesContainer>
      </Container>
    </>
  )
}
